module.exports = __webpack_public_path__ + "static/media/3327590.396fcd46.jpg";